//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';

export default {
  name: 'Lightbox',
  components: {NsIcon},
  props: {
    open: Boolean
  },
  data() {
    return {
      localOpen: this.open
    };
  },
  watch: {
    open(value) {
      this.localOpen = value;
      if (value) {
        window.addEventListener('keydown', this.handleKeydown);
      } else {
        window.removeEventListener('keydown', this.handleKeydown);
      }
    }
  },
  beforeDestroy() {
    if (this.open) {
      window.removeEventListener('keydown', this.handleKeydown);
    }
  },
  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.handleCloseLightbox();
      }
    },
    handleCloseLightbox() {
      this.localOpen = false;
      this.$emit('close');
    }
  }
};
